import { timeline } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function TruthTimeline() {
  return (
    <section id="archive" className="scroll-mt-16 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              index="04"
              eyebrow="Archive"
              title="真相档案"
              desc="按时间线留存每一段拆解过程。真相不是一句结论，而是一串可以被复查的节点，每一步都留档备核。"
            />
            <div className="hidden rounded-lg border border-background-300 bg-background-100 p-5 lg:block">
              <p className="text-xs uppercase tracking-widest text-foreground-500">档案原则</p>
              <ul className="mt-3 space-y-2 text-sm text-foreground-700">
                <li className="flex items-center gap-2"><i className="ri-check-line text-primary-600" />节点可复查</li>
                <li className="flex items-center gap-2"><i className="ri-check-line text-primary-600" />留白不脑补</li>
                <li className="flex items-center gap-2"><i className="ri-check-line text-primary-600" />随时可更新</li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative space-y-0 border-l border-background-300 pl-6">
              {timeline.map((t, i) => (
                <li key={t.date} className="relative pb-7 last:pb-0">
                  <span
                    className={`absolute -left-[35px] top-1 grid h-5 w-5 place-items-center rounded-full border-2 bg-background-50 ${
                      i === 0 ? "border-primary-500" : "border-accent-500/70"
                    }`}
                  >
                    <span className={`h-1.5 w-1.5 rounded-full ${i === 0 ? "bg-primary-500" : "bg-accent-500/80"}`} />
                  </span>
                  <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{t.title}</h3>
                    <span className="shrink-0 font-mono text-xs text-foreground-500">{t.date}</span>
                  </div>
                  <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-foreground-600">{t.desc}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}